document.addEventListener('DOMContentLoaded', function() {
  // Function to filter featured collection products
  function filterFeaturedCollection() {
    const urlParams = new URLSearchParams(window.location.search);
    const featuredCollections = document.querySelectorAll('[data-collection-handle]');
    
    featuredCollections.forEach(function(collection) {
      const products = collection.querySelectorAll('[data-product-id]');
      let visibleProducts = [];
      
      products.forEach(function(product) {
        let shouldShow = true;
        
        // Check vendor filter
        const vendorFilter = urlParams.get('filter.v.option.vendor');
        if (vendorFilter && shouldShow) {
          const productVendor = product.dataset.productVendor;
          const vendorFilters = vendorFilter.split(',').map(v => v.toLowerCase().trim());
          shouldShow = vendorFilters.includes(productVendor);
        }
        
        // Check product type filter
        const typeFilter = urlParams.get('filter.v.option.product_type');
        if (typeFilter && shouldShow) {
          const productType = product.dataset.productType;
          const typeFilters = typeFilter.split(',').map(t => t.toLowerCase().trim());
          shouldShow = typeFilters.includes(productType);
        }
        
        // Check tag filters
        const tagFilter = urlParams.get('filter.v.option.tag');
        if (tagFilter && shouldShow) {
          const productTags = product.dataset.productTags;
          const tagFilters = tagFilter.split(',').map(t => t.toLowerCase().trim());
          shouldShow = tagFilters.some(tag => productTags.includes(tag));
        }
        
        // Check availability filter
        const availabilityFilter = urlParams.get('filter.v.availability');
        if (availabilityFilter && shouldShow) {
          const productAvailable = product.dataset.productAvailable === 'true';
          if (availabilityFilter === '1') {
            shouldShow = productAvailable;
          } else if (availabilityFilter === '0') {
            shouldShow = !productAvailable;
          }
        }
        
        // Check price range filters
        const priceGte = urlParams.get('filter.v.price.gte');
        const priceLte = urlParams.get('filter.v.price.lte');
        if ((priceGte || priceLte) && shouldShow) {
          const productPrice = parseInt(product.dataset.productPrice);
          if (priceGte) {
            const minPrice = parseFloat(priceGte) * 100;
            shouldShow = shouldShow && productPrice >= minPrice;
          }
          if (priceLte) {
            const maxPrice = parseFloat(priceLte) * 100;
            shouldShow = shouldShow && productPrice <= maxPrice;
          }
        }
        
        // Show/hide product
        if (shouldShow) {
          product.style.display = '';
          visibleProducts.push(product);
        } else {
          product.style.display = 'none';
        }
      });
      
      // Handle sorting
      const sortBy = urlParams.get('sort_by');
      if (sortBy && visibleProducts.length > 0) {
        sortProducts(visibleProducts, sortBy);
      }
      
      // Update slider counter if it exists
      const sliderCounter = collection.querySelector('.slider-counter--total');
      if (sliderCounter) {
        sliderCounter.textContent = visibleProducts.length;
      }
    });
  }
  
  // Function to sort products
  function sortProducts(products, sortBy) {
    const productGrid = products[0].parentElement;
    
    // Sort the products array
    products.sort(function(a, b) {
      switch(sortBy) {
        case 'title-ascending':
          return a.querySelector('.card__heading a').textContent.trim().localeCompare(
            b.querySelector('.card__heading a').textContent.trim()
          );
        case 'title-descending':
          return b.querySelector('.card__heading a').textContent.trim().localeCompare(
            a.querySelector('.card__heading a').textContent.trim()
          );
        case 'price-ascending':
          return parseInt(a.dataset.productPrice) - parseInt(b.dataset.productPrice);
        case 'price-descending':
          return parseInt(b.dataset.productPrice) - parseInt(a.dataset.productPrice);
        case 'created-ascending':
          // Oldest first - use product ID as proxy for creation date
          return parseInt(a.dataset.productId) - parseInt(b.dataset.productId);
        case 'created-descending':
        case 'manual':
        default:
          // Newest first or manual - use reverse product ID or maintain original order
          return parseInt(b.dataset.productId) - parseInt(a.dataset.productId);
      }
    });
    
    // Reorder the DOM elements
    products.forEach(function(product) {
      productGrid.appendChild(product);
    });
  }
  
  // Initial filter on page load
  filterFeaturedCollection();
  
  // Listen for URL changes (when filters are applied)
  let lastUrl = location.href;
  new MutationObserver(() => {
    const url = location.href;
    if (url !== lastUrl) {
      lastUrl = url;
      setTimeout(filterFeaturedCollection, 100);
    }
  }).observe(document, {subtree: true, childList: true});
  
  // Also listen for popstate events
  window.addEventListener('popstate', function() {
    setTimeout(filterFeaturedCollection, 100);
  });
  
  // Listen for form submissions in facet forms (including sort forms)
  document.addEventListener('submit', function(e) {
    if (e.target.closest('facet-filters-form') || e.target.id === 'FacetSortForm' || e.target.id === 'FacetSortDrawerForm') {
      setTimeout(filterFeaturedCollection, 500);
    }
  });
  
  // Listen for sort dropdown changes
  document.addEventListener('change', function(e) {
    if (e.target.name === 'sort_by') {
      setTimeout(filterFeaturedCollection, 500);
    }
  });
  
  // Listen for the custom facetsUpdated event from facets.js
  document.addEventListener('facetsUpdated', function() {
    setTimeout(filterFeaturedCollection, 100);
  });
});